<template>
  <m-dropdown
    :title="$t('propsFilter.title')"
    :block="inCardMenu"
    @input="changeVisibility"
  >
    <component
      :is="inCardMenu ? 'm-card-item' : 'm-btn'"
      class="_btn"
      hide-border
      small
      :light="!inCardMenu"
      :icon="inCardMenu ? 'unordered-list' : ''"
    >
      {{ $t('propsFilter.button') }}
    </component>
    <template #overlay>
      <m-card

        class="_overlay"
        border-radius-small
        list
        no-padding
      >
        <slot name="header" />
        <m-tooltip
          placement="left"
          :disabled="!disabled"
          :mouse-enter-delay=".5"
        >
          <div>
            <m-card-item
              v-for="prop in displayableProps"
              :key="prop.key"
              :clickable="!disabled"
              :no-hover="disabled"
              :icon="iconByType({ type: prop.property.type, edgeName: prop.property.edgeName })"
              @click="toggleProp(prop.key)"
            >
              <m-switch
                :key="prop.key"
                :value="prop.show"
                :label="prop.label"
                :disabled="disabled"
                small
                class="_item"
              />
            </m-card-item>
          </div>
          <template #title>
            {{ $t('savedViewInfo.disabledInfo') }}
          </template>
        </m-tooltip>
      </m-card>
    </template>
  </m-dropdown>
</template>

<script>
import { copy } from 'shared/lib/copy';
import { iconByType } from '@/lib/property';

export default {
  name: 'PropsFilter',
  props: {
    value: {
      type: Array,
      required: true,
    },
    inCardMenu: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'update:value', 'update:show', 'change-visibility'],
  data() {
    return { iconByType };
  },
  computed: {
    displayableProps() {
      return this.value.filter((p) => !p.hideInProps);
    },
  },
  methods: {
    toggleProp(key) {
      if (this.disabled) {
        return;
      }
      const cp = copy(this.value);
      let index = -1;
      for (let i = 0; i < cp.length; i++) {
        if (cp[i].key === key) {
          index = i;
          break;
        }
      }
      const newVal = !cp[index].show;
      cp[index].show = newVal;
      this.$emit('input', cp, key);
      this.$emit('update:value', cp, key);
      this.$emit('update:show', { property: cp[index].property, value: newVal });
    },
    changeVisibility(val) {
      this.$emit('change-visibility', val);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  ._overlay {
    min-width: 30rem;

    ._item {
      margin: .8rem 0;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
</style>
